import {TranslationFunction} from "../../../i18n/i18n";
import {CatalogFormatter} from "../../../common/catalog/CatalogFormatter";
import {CatalogType} from "../../../client/catalog/CatalogType";

export class PrefillRequestInformationSystemFormatter {
    static formatInformationSystem(informationSystem: String | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatNsCatalogValueByCode(informationSystem?.valueOf(), CatalogType.INFORMATION_SYSTEMS, t);
    }
}
